<template>
  <nuttrema-layout-form-standard :edit="true" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :rules="rules">

        <section>
          <p class="section-title">{{ $t('label.options') }}</p>
          <div class="section-items">

            <el-form-item :label="$t('label.report_type')" prop="report_type">
              <el-col :span="24">
                <el-select v-model="formData.report_type" class="w-100">
                  <el-option v-for="item in options.report_type" :label="$t(item.label)" :value="item.value" :key="item.value"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           size="small"
           class="w-40"
           type="primary"
           icon="far fa-download"
          :plain="true"
          :loading="formData.action === 'download' && ProgramSchedulesReport.fetching"
          @click="handleDownload">
          {{ $t('label.download_as_pdf') }}
        </el-button>

        <el-button
           size="small"
           class="w-40"
           type="primary"
           icon="far fa-print"
          :plain="true"
          :loading="formData.action === 'print' && ProgramSchedulesReport.fetching"
          @click="handlePring">
          {{ $t('label.print') }}
        </el-button>
      </nav>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { clone } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-program-reports',
  componentName: 'FormProgramReports',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    ProgramSchedulesReport: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        report_type: 'list',
        action: null,
      },
      options: {
        report_type: [
          { label: 'label.schedules_list', value: 'list' },
          { label: 'label.schedules_calendar', value: 'calendar' },
        ],
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.name', true),
          },
        ],
        duration: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.duration', true),
          },
        ],
      },
    };
  },
  methods: {
    handleDownload() {
      this.formData.action = 'download';
      this.submitForm();
    },
    handlePring() {
      this.formData.action = 'print';
      this.submitForm();
    },
    getFormData() {
      return clone(this.formData);
    },
  },
  created() {
    this.stateData = this.ProgramDetails;
    this.formRef = 'form-program-reports';

    this.$on('request-done', () => {
      this.options.loadingPrint = false;
      this.options.loadingDownload = false;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/download/form-program-reports.vue